import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { courseSchema } from '../../../schemas'

export default function Edit({ account, accounts, navigation, course }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title={`Edit: ${course.name}`}
    >
      <BackLink href="/manage/courses">Back to Courses</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={courseSchema}
          resource="course"
          endpoint={`/manage/courses/${course.id}`}
          method="patch"
          backLink="/manage/courses"
          submitLabel="Save Changes"
          defaultValues={{
            name: course.name || '',
            hole_count: course.hole_count || 18
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="hole_count"
                label="Number of Holes"
                type="number"
                required
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
